import React from 'react';
import { Stack, Text, ControlLink } from '@moda/om';
import { useLocation, matchPath } from 'react-router-dom';
import { ACCOUNT_ROUTES, hrefFor } from '../../routers';
import { useUser } from '../../hooks/useUser';

import './AccountNav.scss';

export const AccountNav: React.FC = () => {
  const { pathname } = useLocation();
  const { user } = useUser();

  return (
    <div className="AccountNav">
      <Text family="serif" treatment="h4">
        My Account
      </Text>

      <Stack alignItems="flex-start" className="AccountNav__links" space={2}>
        {ACCOUNT_ROUTES.filter(({ hideFromNav }) => (hideFromNav ? !hideFromNav(user) : true)).map(
          route => (
            <ControlLink
              className="AccountNav__link"
              key={route.key}
              underlined={matchPath(pathname, route) != null}
              to={hrefFor[route.key]()}
            >
              {route.label}
            </ControlLink>
          )
        )}
      </Stack>
    </div>
  );
};
